import { CreditCard } from 'lucide-react'
import { RestrictionScreen } from './RestrictionScreen'
import { GEO_STR as S } from './geoApi'

/**
 * A11.07 — To'lov cheklovlari. REAL `/admin/countries` + greenfield overlay
 * (`/admin/geo/payment-restrictions` → `{code, payment}`): davlat bo'yicha
 * to'lov/premium cheklovi. (MyGram pulsiz — bu premium/telefoniya provayder
 * cheklovlari uchun tayyor turadi.)
 */
export function PaymentRestrictionsScreen() {
  return (
    <RestrictionScreen
      screenId="A11.07"
      title={S.paymentTitle}
      note={S.paymentNote}
      icon={<CreditCard size={28} strokeWidth={1.5} />}
      overlayPath="/admin/geo/payment-restrictions"
      overlayKey="restrictions"
      overlayField="payment"
      overlayHeader={S.payment}
    />
  )
}
